export const formatUtilityAddress = (utilityAddress) =>
  [
    utilityAddress?.unitName,
    utilityAddress?.floors?.map(({ name }) => name).join(", "),
    utilityAddress?.building?.name,
    utilityAddress?.nearestLandmark,
    utilityAddress?.block?.name,
    utilityAddress?.road?.name,
    utilityAddress?.zone?.name,
    utilityAddress?.premiseArea?.name,
  ]
    .filter(Boolean)
    .join(", ");
